"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTyposCSS = exports.getTypoCSS = void 0;
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
var convertObjectToCssVarStrings = function (typo, indent, withDesignPrefix) {
    var prefix = withDesignPrefix ? 'plasma-typo' : 'typo';
    return Object.entries(typo)
        .map(function (_a) {
        var typoKey = _a[0], typoProps = _a[1];
        return Object.entries(typoProps || {})
            .map(function (_a) {
            var typoProp = _a[0], propValue = _a[1];
            return "--".concat(prefix, "-").concat(typoKey, "-").concat(typoProp, ": ").concat(propValue, ";");
        })
            .join("\n".concat(indent));
    })
        .join("\n".concat(indent));
};
var getCommonRootProps = function (withDesignPrefix, displayFontFamily, textFontFamily, getTypoCommonProps) {
    var prefix = withDesignPrefix ? 'plasma-typo' : 'typo';
    var indent = '  ';
    var displayFontFamilyVar = "var(--".concat(prefix, "-display-font-family)");
    var textFontFamilyVar = "var(--".concat(prefix, "-text-font-family)");
    var typoCommonProps = (getTypoCommonProps === null || getTypoCommonProps === void 0 ? void 0 : getTypoCommonProps(displayFontFamilyVar, textFontFamilyVar)) || {};
    var result = convertObjectToCssVarStrings(typoCommonProps, indent, withDesignPrefix);
    return ":root {\n  font-size: 16px;\n  --".concat(prefix, "-overflow-wrap: break-word;\n  --").concat(prefix, "-hyphens: auto;\n  --").concat(prefix, "-display-font-family: '").concat(displayFontFamily, "', sans-serif;\n  --").concat(prefix, "-text-font-family: '").concat(textFontFamily, "', sans-serif;\n  ").concat(result, "\n}");
};
var getBreakpointTypo = function (withDesignPrefix, typeProps, from, to, selector) {
    if (selector === void 0) { selector = ':root'; }
    if (!typeProps) {
        return;
    }
    var indent = '    ';
    var mediaQuery = (0, utils_1.getMediaQuery)(from, to);
    var result = convertObjectToCssVarStrings(typeProps, indent, withDesignPrefix);
    return "".concat(mediaQuery, " {\n  ").concat(selector, " {\n    ").concat(result, "\n  }\n}");
};
var getTypoCSS = function (typoObject, withDesignPrefix) {
    var displayFontFamily = typoObject.displayFontFamily, textFontFamily = typoObject.textFontFamily, getTypoCommonProps = typoObject.getTypoCommonProps, typoS = typoObject.typoS, typoM = typoObject.typoM, typoL = typoObject.typoL;
    return [
        getCommonRootProps(withDesignPrefix, displayFontFamily, textFontFamily, getTypoCommonProps),
        getBreakpointTypo(withDesignPrefix, typoS, 559),
        getBreakpointTypo(withDesignPrefix, typoM, 560, 959),
        getBreakpointTypo(withDesignPrefix, typoL, undefined, 960),
    ];
};
exports.getTypoCSS = getTypoCSS;
var generateTyposCSS = function (typoObjects, withDesignPrefix) {
    if (withDesignPrefix === void 0) { withDesignPrefix = false; }
    var files = [];
    for (var _i = 0, _a = Object.entries(typoObjects); _i < _a.length; _i++) {
        var _b = _a[_i], typoName = _b[0], typeObject = _b[1];
        var typos = (0, exports.getTypoCSS)(typeObject, withDesignPrefix);
        files.push((0, generateFile_1.generateCSSTypoRootFile)(typoName, typos));
    }
    return files;
};
exports.generateTyposCSS = generateTyposCSS;
//# sourceMappingURL=generateTyposCSS.js.map